import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/pro-regular-svg-icons/faPen';

import classNames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { FlexRow } from 'ui-components/components/flex/row';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from './messages';
import style from './style.module.less';

export const ConfigurationReadMode = ({
  inventoryTrackingEnabled,
  inventoryReOrderThreshold,
  startEditing,
  noOnHandStockWarning,
  unknownOnHandStockWarning,
  inventoryShipNoWarehouse,
}) => {
  return (
    <>
      <FlexRow className={style['section-header']}>
        <Text className={style['section-title']} textType={TextType.H3} value={messages.configuration} />
        <FlexRow className={style['section-panel']}>
          <Button className={style['edit-btn']} onClick={startEditing} theme='unstyled'>
            <FontAwesomeIcon className={style['pencil-icon']} icon={faPen} />
            <FormattedMessage {...messages.editButton} />
          </Button>
        </FlexRow>
      </FlexRow>
      <FlexRow className={style['dropdown-option']}>
        <Text
          className={style['option-description']}
          formattedMessageValues={{
            b: (chunks) => <span className={style['underline-title']}>{chunks}</span>,
          }}
          textType={TextType.Paragraph}
          value={messages.noOnHandStockWarningOptionLabel}
        />
        <span className={style['readonly-value']}>{noOnHandStockWarning}</span>
      </FlexRow>
      <FlexRow className={style['dropdown-option']}>
        <Text
          className={style['option-description']}
          formattedMessageValues={{
            b: (chunks) => <span className={style['underline-title']}>{chunks}</span>,
          }}
          textType={TextType.Paragraph}
          value={messages.unknownOnHandStockWarningOptionLabel}
        />
        <span className={style['readonly-value']}>{unknownOnHandStockWarning}</span>
      </FlexRow>
      <FlexRow className={style['dropdown-option']}>
        <Text
          className={style['option-description']}
          formattedMessageValues={{
            b: (chunks) => <span className={style['underline-title']}>{chunks}</span>,
          }}
          textType={TextType.Paragraph}
          value={messages.locationNotTrackingInvWarningOptionLabel}
        />
        <span className={style['readonly-value']}>{inventoryShipNoWarehouse}</span>
      </FlexRow>
      <div className={style['settings-border']} />
      <FlexRow className={style['slider-option']}>
        <div>
          <Text className={style['allow-tracking-message']} textType={TextType.Paragraph} value={messages.allowInventoryTracking} />
          <span className={style['recommended-message']}>
            <FormattedMessage {...messages.recommended} />
          </span>
          <Text className={style['slider-caption']} textType={TextType.Caption} value={messages.enableInventoryTrackingDescription} />
        </div>
        <span
          className={classNames(style['readonly-value'], {
            [style['disabled-readonly-value']]: !inventoryTrackingEnabled,
          })}
        >
          <FormattedMessage {...(inventoryTrackingEnabled ? messages.enabled : messages.disabled)} />
        </span>
      </FlexRow>
      <div className={style['settings-border']} />
      <FlexRow className={style['threshold-option']}>
        <div>
          <Text textType={TextType.Paragraph} value={messages.defaultThresholdWarningOptionLabel} />
          <Text className={style['slider-caption']} textType={TextType.Caption} value={messages.defaultThresholdInfo} />
        </div>
        <span className={classNames(style['readonly-value'])}>
          <FormattedMessage {...messages.units} values={{ units: inventoryReOrderThreshold }} />
        </span>
      </FlexRow>
    </>
  );
};
